import { createMetaReducer, createMiddleware, EventsMapper } from 'redux-beacon'
import { getType } from 'typesafe-actions'
import { ActionTypes as CitationActionTypes } from '@chegg-wt/core/state/citation/constants'
import { ActionTypes } from '../../app/constants'
import {
  COMPONENT_VIEW,
  SUCCESS,
  SIGN_IN_SUCCESS,
  SIGN_UP_SUCCESS,
  VIEW_AUTH_SIGN_UP_MODE,
  syntheticLocationChange,
  userClick,
  signupStart,
  VIEW_AUTH_SIGN_IN_MODE,
  signinStart,
  CLICKSTREAM_NOTIFICATIONS,
} from '../actions'

import RioAnalytics from './rioAnalytics'
import {
  locationChangeEvent,
  clickstreamInteractionEvent,
  clickStreamSignInStartEvent,
  clickStreamNotificationEvent,
  clickStreamSignUpStartEvent,
  clickStreamSignInSuccessEvent,
  clickStreamSignUpSuccessEvent,
  clickStreamSuccessEvent,
  clickStreamComponentViewEvent,
} from './definitions'
import { citationCreationFlowEvent } from './citationCreationFlow/definitions'
import { citationUpdateFlowEvent } from './citationUpdateFlow/definitions'

const rio = RioAnalytics()

export const eventsMap: EventsMapper = (action) => {
  switch (action.type) {
    case getType(syntheticLocationChange):
    case ActionTypes.LOCATION_CHANGE: {
      return locationChangeEvent
    }
    case getType(userClick): {
      return clickstreamInteractionEvent
    }
    case CitationActionTypes.CITATION_CREATE_GTM:
    case CitationActionTypes.CITATION_CREATE_SUCCEEDED: {
      return citationCreationFlowEvent
    }
    case CitationActionTypes.CITATION_UPDATE_SUCCEEDED: {
      return citationUpdateFlowEvent
    }
    case COMPONENT_VIEW: {
      return clickStreamComponentViewEvent
    }
    case SUCCESS: {
      return clickStreamSuccessEvent
    }
    case SIGN_IN_SUCCESS: {
      return clickStreamSignInSuccessEvent
    }
    case CLICKSTREAM_NOTIFICATIONS: {
      return clickStreamNotificationEvent
    }
    case SIGN_UP_SUCCESS: {
      return clickStreamSignUpSuccessEvent
    }
    case getType(signinStart):
    case VIEW_AUTH_SIGN_IN_MODE: {
      return clickStreamSignInStartEvent
    }
    case getType(signupStart):
    case VIEW_AUTH_SIGN_UP_MODE: {
      return clickStreamSignUpStartEvent
    }
    default:
      return []
  }
}

export const wtaMiddleware = createMiddleware(eventsMap, rio)
export const wtaReducer = createMetaReducer(eventsMap, rio)
